import React from 'react';
import { Box, Card, CardContent, LinearProgress, Stack, Typography } from '@mui/material';

import SimplePieChart from '../../shared/SimplePieChart';
import { fmtCurrency } from './openInvoiceFormatters';

export default function OpenInvoiceSummaryCard({ loading, pieData, totalOutstanding }) {
    return (
        <Card sx={{ flex: { lg: '0 0 320px' } }}>
            <CardContent>
                <Typography variant="h6" gutterBottom>
                    Fälligkeitsstruktur
                </Typography>
                {loading ? (
                    <LinearProgress sx={{ mt: 2 }} />
                ) : pieData.length ? (
                    <Stack alignItems="center" spacing={2}>
                        <SimplePieChart data={pieData} size={180} />
                        <Stack spacing={1}>
                            {pieData.map((entry) => (
                                <Stack key={entry.label} direction="row" spacing={1} alignItems="center">
                                    <Box sx={{ width: 12, height: 12, borderRadius: '50%', backgroundColor: entry.color }} />
                                    <Typography variant="body2">{entry.label}</Typography>
                                    <Typography variant="body2" color="text.secondary">
                                        {fmtCurrency(entry.value)}
                                    </Typography>
                                </Stack>
                            ))}
                        </Stack>
                    </Stack>
                ) : (
                    <Typography variant="body2" color="text.secondary">
                        Keine Daten verfügbar.
                    </Typography>
                )}
                <Typography variant="subtitle1" sx={{ mt: 3 }}>
                    Summe offen: {fmtCurrency(totalOutstanding)}
                </Typography>
            </CardContent>
        </Card>
    );
}
